import { render, staticRenderFns } from "./crud_CTC.vue?vue&type=template&id=48cf3ddb&scoped=true"
import script from "./crud_CTC.vue?vue&type=script&lang=js"
export * from "./crud_CTC.vue?vue&type=script&lang=js"
import style0 from "./crud_CTC.vue?vue&type=style&index=0&id=48cf3ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf3ddb",
  null
  
)

export default component.exports